/**
 * Central definition for all payment method types (Payment.Method, backend PaymentMethod enum).
 * Stored as int enum values.
 */

export const PAYMENT_METHOD_SEPA = 1;
export const PAYMENT_METHOD_TRANSFER = 2;
export const PAYMENT_METHOD_CASH = 3;
export const PAYMENT_METHOD_CARD = 4;
export const PAYMENT_METHOD_OTHER = 5;
export const PAYMENT_METHOD_VOUCHER = 6;
export const PAYMENT_METHOD_PAYPAL = 7;
export const PAYMENT_METHOD_DEBT_COLLECTION = 8;
export const PAYMENT_METHOD_STANDING_ORDER = 9;
export const PAYMENT_METHOD_REBOOKING = 10;
export const PAYMENT_METHOD_STRIPE = 11;

export const MANUAL_PAYMENT_METHOD_TYPES: readonly number[] = [
  PAYMENT_METHOD_CASH, PAYMENT_METHOD_TRANSFER, PAYMENT_METHOD_CARD,
  PAYMENT_METHOD_STANDING_ORDER, PAYMENT_METHOD_VOUCHER, PAYMENT_METHOD_OTHER,
];

/** Default when no payment method is provided. */
export const PAYMENT_METHOD_DEFAULT = PAYMENT_METHOD_CASH;

/** All valid enum values. */
export const ALL_PAYMENT_METHOD_TYPES = [
  PAYMENT_METHOD_CASH,
  PAYMENT_METHOD_CARD,
  PAYMENT_METHOD_SEPA,
  PAYMENT_METHOD_TRANSFER,
  PAYMENT_METHOD_STANDING_ORDER,
  PAYMENT_METHOD_VOUCHER,
  PAYMENT_METHOD_PAYPAL,
  PAYMENT_METHOD_STRIPE,
  PAYMENT_METHOD_DEBT_COLLECTION,
  PAYMENT_METHOD_REBOOKING,
  PAYMENT_METHOD_OTHER,
] as const;

/** Default label translation keys per enum value. */
export const PAYMENT_METHOD_LABELS: Record<number, string> = {
  [PAYMENT_METHOD_SEPA]: "Direct debit",
  [PAYMENT_METHOD_TRANSFER]: "Bank transfer",
  [PAYMENT_METHOD_STANDING_ORDER]: "Standing order",
  [PAYMENT_METHOD_CASH]: "Cash",
  [PAYMENT_METHOD_CARD]: "Card",
  [PAYMENT_METHOD_OTHER]: "Other",
  [PAYMENT_METHOD_VOUCHER]: "Voucher",
  [PAYMENT_METHOD_PAYPAL]: "PayPal",
  [PAYMENT_METHOD_STRIPE]: "Stripe",
  [PAYMENT_METHOD_DEBT_COLLECTION]: "Debt collection",
  [PAYMENT_METHOD_REBOOKING]: "Rebooking",
};
